module.exports = __webpack_public_path__ + "img/s6_img.cba05307.png";